import React from 'react';
import { classNames, hyphenateAndLowercase } from '../dom';

import * as icons from './Icons';

import './Icon.scss';

export interface IconProps {
  /** Icon name matches file name */
  name: string;
  /** CSS class to pass to underlying svg node */
  className?: string;
  /** Wrapper Type: wrap an icon with either a circle or square border */
  wrapper?: 'circle' | 'square';
  /** Makes the icon white and if wrapped in shape, fills the wrapper,
   * set ".ps-icon.ps-icon--inverted .ps-icon__outline" to change background color */
  inverted?: boolean;
  /** Spin the icon */
  spin?: boolean;
}

type IconElement = React.MemoExoticComponent<(props: React.SVGProps<SVGSVGElement>) => JSX.Element> | any;

// dynamic lookup of Icons by name (passed in as a prop)
const iconSet: { [index: string]: IconElement } = icons;

export const Icon: any = (props: IconProps) => {
  const { name, className, wrapper, spin, inverted = false } = props;
  const kebabCasedName = hyphenateAndLowercase(name);
  const iconClassNames = classNames(
    'ps-icon',
    `ps-icon--${kebabCasedName}`,
    wrapper ? `ps-icon--${wrapper}` : '',
    spin ? `ps-icon--is-spinning` : '',
    inverted ? `ps-icon--inverted` : '',
    className
  );

  if (inverted && !wrapper) {
    throw new Error('You must specify a wrapper to have an inverted icon.');
  }

  if (icons && iconSet[name]) {
    const SelectedIcon = iconSet[name];

    if (wrapper) {
      return (
        <span className={iconClassNames}>
          <span className="ps-icon__outline">
            <SelectedIcon />
          </span>
        </span>
      );
    }
    return <SelectedIcon className={iconClassNames} />;
  }

  console.error(`Icon not found ${name}`);
  return null;
}
